import { FC, SVGProps } from 'react';

const CustomFieldMultiSelectIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 16,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2046 2.41272H4.96881C3.14419 2.41272 2 3.70481 2 5.53331V10.4668C2 12.2947 3.13836 13.5868 4.96881 13.5868H10.2039C12.0344 13.5868 13.1741 12.2947 13.1741 10.4668V5.53331C13.1741 3.70481 12.0344 2.41272 10.2046 2.41272Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 3.54626C10.5648 5.20936 8.46644 8.2411 7.50451 10.0482C6.88704 9.0123 6.10413 8.09124 5.15259 7.28824"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomFieldMultiSelectIcon;
